export default __webpack_public_path__ + "static/media/completed-img.1d7b0891.png";